import { useCallback, useEffect, useRef, useState } from "react";

export default function useInputSearch({
  filterSorting,
}: {
  filterSorting: Function;
}) {
  const [searchString, setSearchString] = useState("");
  const searchTimeoutRef = useRef<number | undefined>(undefined);

  const handleKeyPress = useCallback(
    (e: KeyboardEvent) => {
      // For Command+1 and Command+2
      if (
        (e.metaKey || e.ctrlKey || (e.ctrlKey && e.altKey)) &&
        (e.key === "1" || e.key === "2" || e.key === "3")
      ) {
        e.preventDefault();

        if (e.key === "1") {
          return filterSorting(0);
        } else if (e.key === "2") {
          return filterSorting(1);
        } else if (e.key === "3") {
          return filterSorting(2);
        }
      }

      if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
        if (searchTimeoutRef.current) {
          window.clearTimeout(searchTimeoutRef.current);
        }
        setSearchString((s) => s + e.key);
        searchTimeoutRef.current = window.setTimeout(() => {
          setSearchString("");
        }, 2000); // Resets search string after 2 seconds of inactivity
      }
    },
    [filterSorting],
  );

  useEffect(() => {
    window.addEventListener("keyup", handleKeyPress);

    return () => {
      window.removeEventListener("keyup", handleKeyPress);

      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [handleKeyPress]);

  return searchString;
}
